import { useMutation } from '@tanstack/react-query';

export function useCreateReviewReminderMutation() {
  return useMutation({
    mutationFn: async ({ id }) => {
      const response = await axios.post(`/reviews/${id}/reminders`);

      return response.data;
    },
  });
}
